package com.patronat.top.features.venues.domain.usecase.command

import com.patronat.top.dto.UpdateVenueRequest

data class UpdateVenueCommand(
    val venueId: String,
    val request: UpdateVenueRequest
)
